export const styles = {};

export const overrides = {
	'.threshold360-iframe__responsive': {
		width: '100%',
		height: 'auto',
		border: 0,
		aspectRatio: '20/9',
	}
};

export default styles;